import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import SafeLink from "./SafeLink";

const DISALLOWED = [
  "img","video","audio","iframe","object","embed","svg","math",
  "script","style","link","meta","html","head","body","form","input","button",
  "picture","source","track",
];

export default function SafeMarkdown({ children }) {
  return (
    <ReactMarkdown
      skipHtml={true}
      remarkPlugins={[remarkGfm]}
      disallowedElements={DISALLOWED}
      unwrapDisallowed={true}
      components={{ a: SafeLink }}
    >
      {typeof children === "string" ? children : ""}
    </ReactMarkdown>
  );
}
